module.exports = __webpack_public_path__ + "img/denti_i_logo_jbe.d224968c.png";